// extracted by mini-css-extract-plugin
module.exports = {"Container":"TestAccountBanner_Container__yxu8V","Banner":"TestAccountBanner_Banner__3rY9w","InfoIcon":"TestAccountBanner_InfoIcon__oIjkC"};